<template>
  <div class="bradesco">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="bradesco__line"></div>
          <img :src="BradescoIcon">
        </div>
      </div>
    </div>    
  </div>
</template>

<script>
import BradescoIcon from '@/icons/bradesco.svg'

export default {
  name: 'BradescoLine',
  data: () => ({
    BradescoIcon,
  })
}
</script>

<style lang="scss" scoped>
.bradesco {
  margin-top: 50px;
  position: relative;
  text-align: right;
  @media (max-width: 992px) {
    padding-bottom: 30px;
  }
  &__line {
    height: 1px;
    background: #e1bac6;
    width: 100vw;
    position: absolute;
    bottom: 15px;
    right: 125px;
  }
}
</style>
